import { memo } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Typography } from '@components/Typography';
import Avatar from '@components/Avatar';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import { getInitialsParts, getUserContacts, getFullName } from '@helpers/userName';
import {
    MainSection,
    Footer,
    ItemContainer,
    HeaderRow,
    WrapperContact,
    WrapperContactName,
    NameRow,
    ChipsContainer,
    Actions,
    WrapperRating,
    CssRating,
    StyledUserIcon,
} from './styles';

const ResponseItem = memo(
    ({
        index,
        body,
        footer,
        footerStyles,
        chips,
        nameChip,
        actions,
        contactDetailsLink,
        firstName,
        lastName,
        phoneNumber,
        email,
        contactExternalId,
        userNameTitle,
        viewed,
        rating,
        date,
        userProfileImg,
    }) => {
        const isMobile = useMediaQuery('@media (max-width: 1024px)');
        return (
            <ItemContainer
                elevation={1}
                key={`feedback-${index}`}
                style={{ background: viewed ? 'var(--light-main)' : 'var(--action-highlight)' }}
            >
                <MainSection>
                    <HeaderRow withActions={!!actions}>
                        <WrapperContact>
                            <Avatar
                                size={isMobile ? 'medium' : 'large'}
                                fullName={getFullName(firstName, lastName)}
                                image={userProfileImg}
                                label={getInitialsParts(firstName, lastName)}
                                icon={<StyledUserIcon />}
                            />
                            <WrapperContactName>
                                {(() => {
                                    const nameTypography = (
                                        <Typography variant="subtitle1" color="textPrimary" style={{ marginBottom: 0 }}>
                                            {getUserContacts(
                                                {
                                                    firstName,
                                                    lastName,
                                                    phoneNumber: phoneNumber?.length > 4 ? phoneNumber : undefined,
                                                    email,
                                                    externalId: contactExternalId,
                                                },
                                                '-',
                                            )}{' '}
                                            {userNameTitle}
                                        </Typography>
                                    );
                                    return nameChip ? (
                                        <NameRow>
                                            {nameTypography}
                                            {nameChip}
                                        </NameRow>
                                    ) : (
                                        nameTypography
                                    );
                                })()}
                                {contactDetailsLink && <>{contactDetailsLink}</>}
                            </WrapperContactName>
                        </WrapperContact>
                        {(chips || actions) && (
                            <ChipsContainer>
                                {chips}
                                {actions && <Actions>{actions}</Actions>}
                            </ChipsContainer>
                        )}
                    </HeaderRow>
                    <WrapperRating>
                        <CssRating
                            size="small"
                            name="read-only"
                            value={rating || 0}
                            readOnly
                            icon={<StarRoundedIcon fontSize="inherit" />}
                            emptyIcon={<StarRoundedIcon fontSize="inherit" sx={{ color: '#E4EAEB' }} />}
                        />
                        {date && (
                            <Typography variant="caption" color="textSecondary">
                                {date}
                            </Typography>
                        )}
                    </WrapperRating>
                    {body}
                </MainSection>
                {footer && <Footer style={{ ...footerStyles }}>{footer}</Footer>}
            </ItemContainer>
        );
    },
);

ResponseItem.displayName = 'ResponseItem';

export default ResponseItem;
